<template>
    <div v-if="!disactive" :class="['form-group', size]">
        <label :for="name">{{ label }}</label>
        <input :type="type" v-bind:class="'form-control ' + (errors !== null ? 'error-input' : '')" :name="name" :value="modelValue" @change="checkMail"  :placeholder="placeholder" @input="updateValue($event.target.value)" :required="this.name != 'flat_number'" maxlength="150">
        <div class="error" v-if="errors">
            <ul>
                <li v-for="error in errors" v-html="error"></li>
            </ul>
        </div>
        <div class="error" v-if="emailUsed && register">
            <ul>
                <li>Ten adres e-mail już istnieje w systemie Med-Space, prosimy zalogować się <a href="/logowanie">TUTAJ</a> </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: ['label', 'type', 'name', 'placeholder', 'size', 'disactive', 'errorMessages', 'register', 'modelValue'],

    methods: {
        updateValue(value) {
            this.$emit('input', value);
            this.value = value;
            if(this.errorMessages && this.name in this.errorMessages) {
                this.value = value;
            }
        },

        checkMail() {
            if(this.register && this.name === 'email'){
                axios.get('/api/checkMail', {
                    params: {
                        email: this.value,
                    }
                }).then(response => {
                    this.emailUsed = response.data.data.isUsed;
                });
            }
        }
    },
    data() {
        return {
            value: '',
            emailUsed: false,
        };
    },
    computed: {
        errors: function () {
            if(this.errorMessages && this.name in this.errorMessages && this.value === '') {
                return this.errorMessages[this.name];
            }

            return null;
        }
    },
    watch: {
        errorMessages: function(newValue, oldValue) {
            this.value = '';
        }
    }
}
</script>
